(function () {
  function initPillarBanner(root) {
    var pillars = root.querySelectorAll('.pb-pillar');
    var backgrounds = root.querySelectorAll('.pb-bg');
    var descriptions = root.querySelectorAll('.pb-desc');

    if (!pillars.length) return;

    function activate(idx) {
      pillars.forEach(function (p) {
        var on = p.dataset.pillar === idx;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      backgrounds.forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.bg === idx);
      });
      descriptions.forEach(function (d) {
        d.classList.toggle('is-active', d.dataset.desc === idx);
      });
    }

    var autoplayInterval = parseInt(root.dataset.autoplayInterval, 10) || 0;
    var currentIndex = 0;
    var timer = null;

    function startTimer() {
      if (autoplayInterval <= 0) return;
      clearInterval(timer);
      timer = setInterval(function () {
        currentIndex = (currentIndex + 1) % pillars.length;
        activate(pillars[currentIndex].dataset.pillar);
      }, autoplayInterval);
    }

    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    pillars.forEach(function (pillar) {
      pillar.addEventListener('mouseenter', function () {
        currentIndex = parseInt(pillar.dataset.pillar, 10) - 1;
        activate(pillar.dataset.pillar);
        resetTimer();
      });
      pillar.addEventListener('click', function () {
        currentIndex = parseInt(pillar.dataset.pillar, 10) - 1;
        activate(pillar.dataset.pillar);
        resetTimer();
      });
      pillar.addEventListener('focus', function () {
        currentIndex = parseInt(pillar.dataset.pillar, 10) - 1;
        activate(pillar.dataset.pillar);
        resetTimer();
      });
    });

    startTimer();
  }

  document.querySelectorAll('.pillar-banner').forEach(initPillarBanner);

  function moveScreenTo(url) {
    var element = document.querySelector(url);
    if (!element) return;
    var top = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  window.moveScreenTo = moveScreenTo;
})();
